import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/auth/authSlice";
import service from "../services/service";
import endpoints from "../services/endpoints";
import { Logout } from "../assests/ExportImageIcon";
import "./header.css";

const Header = ({ onToggle }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const refresh_token = useSelector((state) => state.auth.refresh_token);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSignOut = async () => {
    setLoading(true);
    try {
      await service.post(endpoints.auth.logout, { refresh: refresh_token }, { skipToast: true });
      localStorage.removeItem("loginTimestamp");
    } catch {
      // proceed with logout even if API fails
    } finally {
      dispatch(logout());
      navigate("/", { replace: true });
      setLoading(false);
      setShowConfirm(false);
    }
  };

  return (
    <>
      {showConfirm && (
        <div className="confirm-overlay">
          <div className="confirm-modal">
            <h3>Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div className="confirm-actions">
              <button className="confirm-cancel" onClick={() => setShowConfirm(false)} disabled={loading}>
                Cancel
              </button>
              <button className="confirm-ok commonOrngBtn" onClick={handleSignOut} disabled={loading}>
                {loading ? "Logging out..." : "Logout"}
              </button>
            </div>
          </div>
        </div>
      )}

      <header className="top-header">
        <div className="header-left">
          <button className="hamburger-btn" onClick={onToggle}>☰</button>
        </div>

        <div className="header-right">
          <div className="logoutBtn cursorPointer" onClick={() => setShowConfirm(true)}>
            <img src={Logout} alt="logout" />
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
